/**
 * Initializes the product detail buttons.
 *
 * This function sets up an event listener on elements with the class "js-pd-button".
 * When these buttons are clicked, the browser will navigate to the URL specified in the
 * data-url attribute of the clicked button.
 */
const initializePdButtons = () => {
    let $pdButtons = $(".js-pd-button");

    if (!$pdButtons.length) {
        return;
    }

    $pdButtons.each(function () {
        $(this).on("click", function () {
            let url = $(this).data("url");
            if (url) {
                const targetProperty = "_blank";
                // If the button has the intended target attribute, open the URL in a new tab.
                const target = $(this).attr("target");
                if (target === targetProperty) {
                    window.open(url, "_blank", "noopener");
                } else {
                    window.location.href = url;
                }
            }
        });
    });
};

module.exports = {
    initializePdButtons: initializePdButtons
};
